import { redirect } from "@tanstack/react-router";

import { LinkTo } from "@/@types/routing";
import { RouterContext } from "@/main";
import { Role } from "@/store";

import { normalizeRole } from "./normalizeRole";

type RequiredRolesParams = {
  allowed?: Role[];
  notAllowed?: Role[];
  fallback?: LinkTo;
};
export const requireRoles =
  ({ allowed = [], notAllowed = [], fallback = "/403" }: RequiredRolesParams) =>
  ({ context }: { context: RouterContext }) => {
    const store = context.store;
    const state = store.getState();
    const {
      auth: { driver, expedition }
    } = state;

    const token = expedition?.accessToken || driver?.accessToken;
    const role = normalizeRole(expedition?.role || driver?.role) as Role | undefined;

    if (!token) {
      throw redirect({ to: fallback });
    }

    if (!role) {
      throw redirect({ to: fallback });
    }

    const isAllowedViolated = allowed && !allowed.includes(role);
    const isNotAllowedViolated = notAllowed && notAllowed.includes(role);

    if (isAllowedViolated || isNotAllowedViolated) {
      throw redirect({ to: fallback });
    }
  };
